import React, { useState } from 'react';
import Panel from '@prisjakt/ui-panel';
import T from '@prisjakt/ui-translate';
import Placeholder from '../placeholder';
import PriceInformation from '../../price-information';
import { getSortedPrices } from '../utils/sorting';
import PriceListHeader from './price-list-header';
import PriceListFooter from './price-list-footer';
import PriceListBody from './price-list-body';
import { IPriceListPanelProps } from './types';
import { getListPrices, getCommonListProps, getListLimits } from './utils';
import { SortOptionEnum } from '../offer-list-sorting/types';

function splitPriceList(currentSorting: SortOptionEnum): boolean {
  switch (currentSorting) {
    default:
    case SortOptionEnum.PRICE:
      return false;
    case SortOptionEnum.RECOMMENDED:
      return true;
    case SortOptionEnum.PRICEANDSTOCKSTATUS:
      return true;
  }
}

const PriceListPanel: React.FC<IPriceListPanelProps> = props => {
  const [showMorePrices, setShowMorePrices] = useState(false);
  const [showMoreUnfeaturedPrices, setShowUnfeaturedMorePrices] = useState(
    false
  );

  const sortedPrices = getSortedPrices(
    props.priceDisplay,
    props.currentSorting,
    props.prices
  );

  const isGroupedList = splitPriceList(props.currentSorting);

  const prices = getListPrices(sortedPrices, isGroupedList);
  const commonListProps = getCommonListProps(props);
  const listLimits = getListLimits(prices, isGroupedList);

  return (
    <Panel>
      <PriceListHeader />
      {props.storeStatistics && (
        <PriceInformation storeStatistics={props.storeStatistics} />
      )}

      {sortedPrices && sortedPrices.length > 0 ? (
        <>
          <PriceListBody
            sortedPrices={prices.mainList}
            showMorePrices={showMorePrices}
            numberOfVisiblePrices={listLimits.mainListLimit}
            splitList={isGroupedList}
            {...commonListProps}
          />
          <PriceListFooter
            showProductInformationTexts={props.showProductInformationTexts}
            sortedPrices={prices.mainList}
            showMorePrices={showMorePrices}
            numberOfVisiblePrices={listLimits.mainListLimit}
            setShowMorePrices={setShowMorePrices}
          />
          {isGroupedList &&
            prices.stockStatusUnknownList &&
            prices.stockStatusUnknownList.length > 0 && (
              <>
                <h3>
                  <T domain="product" product="splitlist-other.title">
                    splitlist-other.title
                  </T>
                </h3>
                <PriceListBody
                  sortedPrices={prices.stockStatusUnknownList}
                  showMorePrices={showMoreUnfeaturedPrices}
                  numberOfVisiblePrices={listLimits.stockStatusUnknownListLimit}
                  splitList={isGroupedList}
                  {...commonListProps}
                />
                <PriceListFooter
                  showProductInformationTexts={
                    props.showProductInformationTexts
                  }
                  sortedPrices={prices.stockStatusUnknownList}
                  showMorePrices={showMoreUnfeaturedPrices}
                  numberOfVisiblePrices={listLimits.stockStatusUnknownListLimit}
                  setShowMorePrices={setShowUnfeaturedMorePrices}
                />
              </>
            )}
        </>
      ) : (
        <Placeholder category={props.category} />
      )}
    </Panel>
  );
};

export default PriceListPanel;
